import { ArrowBack, Refresh, School } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { TrainingView } from "@my-helpers/common";

interface TrainingHeaderProps {
    currentTraining?: TrainingView;
    refreshTraining: (trainingId: string) => void;
}

const TrainingHeader: React.FC<TrainingHeaderProps> = ({
    currentTraining,
    refreshTraining
}) => {
    const theme = useTheme();
    const navigate = useNavigate();
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            pb: theme.spacing(2),
            flexShrink: 0
        }}>
            <School sx={{
                fontSize: '2.2rem',
                color: 'primary.main'
            }} />
            <Box sx={{ flexGrow: 1 }}>
                <Typography
                    sx={{
                        fontWeight: 500,
                        fontSize: '1.6rem',
                        padding: '4px 0',
                    }}>
                    {currentTraining?.name || ''}
                </Typography>
            </Box>
            <Tooltip title="Refresh trainings">
                <IconButton 
                    color="primary" 
                    onClick={() => {
                        if (!currentTraining?.id) {
                            return;
                        }
                        refreshTraining(currentTraining?.id)
                    }}>
                    <Refresh />
                </IconButton>
            </Tooltip>
            <Tooltip title="Back to trainings">

                <IconButton
                    onClick={() => navigate('/trainings')}
                    sx={{
                        color: 'primary.light',
                        backgroundColor: 'lightGray',
                        flexShrink: 0,
                        '&:hover': {
                            color: 'white',
                            backgroundColor: 'primary.light',
                        }
                    }}
                >
                    <ArrowBack />
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default TrainingHeader;